import type { DriveStep } from 'driver.js';

export const POS_TABLE_MODAL_TOUR_KEY = 'modal-pos-table';

export const posTableModalTour: DriveStep[] = [
  {
    element: '[data-tour="modal-pos-table-details"]',
    popover: {
      title: 'Table details',
      description:
        'Table number appears on floor plans and order screens. Display name is shown to staff; capacity drives seating warnings.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="modal-pos-table-zone"]',
    popover: {
      title: 'Zone placement',
      description:
        'Assign the table to a dining zone for filtering the grid and floor plan. Manage zones from the Tables page toolbar.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="modal-pos-table-status"]',
    popover: {
      title: 'Status & notes',
      description:
        'Set availability (available, occupied, reserved, cleaning). Notes help hosts communicate table-specific instructions.',
      side: 'top',
      align: 'start',
    },
  },
];
